module.exports = __webpack_public_path__ + "static/media/kuibishan_package.9e5fc693.webp";